import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Chip from '@mui/material/Chip';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import serverApi from '../../api/server'
import { Typography } from 'antd';
const {Text} = Typography;
interface Merchant {
    Name: string;
    Description: string;
    Tags: string[];
}
function EditMerchant({curMerchant, openEditMerchant, handleCloseEditMerchant, update, setUpdate} : any) {
    const [merchant, setMerchant] = React.useState<Merchant>();
    const [inputTag, setInputTag] = React.useState<string>('');
    const [selectedTags, setSelectedTags] = React.useState<string[]>([]);
    const [warning, setWarning] = React.useState(false);
    const [warningMsg, setWarningMsg] = React.useState('')
    useEffect(() => {
        console.log(curMerchant)
        if(curMerchant){
            
            setMerchant(curMerchant)
            setSelectedTags(curMerchant.Tags)
        }
        
    },[curMerchant])
    const handleChange = (type: any, event: any) => {
        let updateMerchant = Object.assign({}, merchant)
        if(type === 'name') {
            updateMerchant.Name = event.target.value
            setMerchant(updateMerchant)
        }
        else if(type === 'description') {
            updateMerchant.Description = event.target.value
            setMerchant(updateMerchant)
        }
        else if(type === 'tags') {
            console.log(event.target.value)
            // updateMerchant.Tags = event.target.value
            // setCurAsset(updateAsset)
        }
    }
    const inputChange = (event: any) => {
        setInputTag(event.target.value)
    };
    const handleSelectTagsKeyDown = ({key} : any) => {
        if(key === 'Enter') {
            let tagArr = [...selectedTags]
            if(tagArr.length >= 5) {
                setWarning(true)
                setWarningMsg("Max tag limit(5) has been reached!")
            }
            else {
                if(!tagArr.includes(inputTag)){
                    tagArr.push(inputTag)
                    setSelectedTags(tagArr)
                }
                setInputTag("")
            }
        }
    }
    const handleDeleteTagInput = (item: string) => {
        let tagArr = [...selectedTags]
        let position = tagArr.indexOf(item)
        tagArr.splice(position, 1)
        setSelectedTags(tagArr)
    }
    const handleCreateNewMerchant = async() => {
        try{
            const jsonData = {
                prevname: curMerchant.Name,
                name: merchant?.Name,
                description: merchant?.Description,
                tags: selectedTags
            };
            console.log(jsonData)
            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const path = 'api/updateClient' 

            //const signature = generateSignature("POST", timeStamp, path, null, jsonData) 

            const res = await serverApi.post(`/updateMerchant`, jsonData, 
                //{headers: {Authorization: signature}}
            )
            console.log(res)
            if(res){
                let count = update + 1
                setUpdate(count)
                setSelectedTags([])
                setMerchant(undefined)
                handleCloseEditMerchant()

            }
        }
        catch(err){
            console.log(err)
            setWarning(true)
            setWarningMsg("Error: Updating Merchant - " + err)
        }
    }
    return (
        <>
        <Dialog open={openEditMerchant} onClose={handleCloseEditMerchant} maxWidth={'md'} fullWidth={true}>
            <DialogTitle>New Merchant</DialogTitle>
            <DialogContent>
                <div className='dialogRow'>
                    <Text className='label' strong>User Id: </Text>
                    <TextField 
                        id="standard-basic" 
                        variant="standard" 
                        sx={{width: '60%'}}
                        value={merchant?.Name} 
                        disabled={true}
                        onChange={(e) => handleChange('name', e)}/>
                </div>
                <div className='dialogRow'>
                    <Text className='label' strong>Email: </Text>
                    <TextField
                        id="outlined-multiline-static"
                        // label="Wallet Address"
                        variant="standard" 
                        sx={{width: '40%'}}
                        disabled={true}
                        value={merchant?.Description}
                        onChange={(e) => handleChange('description', e)}
                    />
                </div>
                <div className='dialogRow'>
                    <Text className='label' strong>Tags: </Text>
                    <TextField
                            fullWidth
                            variant="outlined"
                            label="Tags"
                            // multiline
                            value={inputTag}
                            onChange={inputChange}
                            onKeyDown={handleSelectTagsKeyDown}
                            // multiline
                            InputProps={{
                                startAdornment: 
                                selectedTags.map((item: string) => (
                                        <Chip
                                            key={item}
                                            label={item}
                                            sx={{marginRight: 1}}
                                            onDelete={() => handleDeleteTagInput(item)}
                                        />
                                    ))
                            }}
                        />
                </div>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCloseEditMerchant}>Cancel</Button>
            <Button onClick={handleCreateNewMerchant} disabled={!merchant?.Name || !merchant.Description}>Save</Button>
            </DialogActions>
        </Dialog>
        <Snackbar open={warning} autoHideDuration={6000} onClose={() => setWarning(false)}>
            <Alert severity="warning">{warningMsg}</Alert>
        </Snackbar>
        </>
    );
}

export default EditMerchant;